<div
  class="mb-4 flex flex-col gap-2"
  (click)="closeAllDropdowns()">
  <div class="grid grid-cols-3 gap-6 pt-4" [dir]="isArabic() ? 'rtl' : 'ltr'">
    <div class="group relative">
      <label
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
        i18n="@@users.fullName">
        Full Name
      </label>
      <div class="relative">
        <input
          type="text"
          [ngModel]="localFilters().fullName"
          (ngModelChange)="onFullNameChange($event)"
          (focus)="onFullNameFocus()"
          (click)="$event.stopPropagation()"
          placeholder="Search by name..."
          i18n-placeholder="@@searchUsers"
          class="w-full rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] text-gray-700 transition-colors outline-none placeholder:text-gray-300 hover:border-gray-600 focus:border-black ltr:pr-4 ltr:pl-10 rtl:pr-10 rtl:pl-4" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="absolute top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400 transition-colors group-focus-within:text-black group-hover:text-gray-600 ltr:left-3 rtl:right-3"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        @if (showFullNameDropdown() && fullNameResults().length > 0) {
          <div
            (click)="$event.stopPropagation()"
            class="absolute z-[110] mt-1 max-h-52 w-full overflow-y-auto rounded-md border bg-white shadow-lg">
            @for (item of fullNameResults(); track item.id) {
              <button
                (click)="selectFullName(item)"
                class="block w-full cursor-pointer border-b border-gray-50 px-4 py-2 text-start text-sm transition-colors last:border-0 hover:bg-gray-100">
                {{ item.name }}
              </button>
            }
          </div>
        }
      </div>
    </div>

    <div class="group relative">
      <label
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
        i18n="@@users.role">
        Role
      </label>
      <div class="relative w-full" (click)="$event.stopPropagation()">
        <button
          type="button"
          (click)="onToggleRoleMenu($event)"
          class="flex w-full appearance-none items-center justify-between rounded-[10px] border border-gray-400 bg-white py-2.5 pr-4 pl-4 text-[14px] text-gray-700 transition-colors outline-none hover:cursor-pointer hover:border-gray-600 focus:border-black">
          <span
            class="truncate"
            [class.text-gray-400]="selectedRoleId() === null"
            [class.font-bold]="selectedRoleId() !== null">
            {{ getRoleLabel() }}
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="pointer-events-none h-5 w-5 text-black transition-transform"
            [class.rotate-180]="isRoleMenuOpen()"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        @if (isRoleMenuOpen()) {
          <div
            (click)="$event.stopPropagation()"
            class="absolute z-50 mt-1 w-full rounded-[10px] border border-gray-200 bg-white shadow-lg">
            <div
              (click)="selectRole(null)"
              class="flex cursor-pointer items-center gap-2 px-4 py-2.5 text-[14px] hover:bg-gray-50"
              [class.bg-gray-100]="selectedRoleId() === null">
              <div
                class="flex h-4 w-4 items-center justify-center rounded-full border-2"
                [class.border-black]="selectedRoleId() === null"
                [class.border-gray-300]="selectedRoleId() !== null">
                @if (selectedRoleId() === null) {
                  <div class="h-2 w-2 rounded-full bg-black"></div>
                }
              </div>
              <span>{{ isArabic() ? "كل الوظائف" : "All Roles" }}</span>
            </div>
            <hr class="border-gray-100" />
            @for (role of rolesList(); track role.id) {
              <div
                (click)="selectRole(role.id)"
                class="flex cursor-pointer items-center gap-2 px-4 py-2.5 text-[14px] hover:bg-gray-50"
                [class.bg-gray-100]="selectedRoleId() === role.id">
                <div
                  class="flex h-4 w-4 items-center justify-center rounded-full border-2"
                  [class.border-black]="selectedRoleId() === role.id"
                  [class.border-gray-300]="selectedRoleId() !== role.id">
                  @if (selectedRoleId() === role.id) {
                    <div class="h-2 w-2 rounded-full bg-black"></div>
                  }
                </div>
                <span>{{ isArabic() ? role.titleAr : role.titleEn }}</span>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <div class="group relative">
      <label
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
        i18n="@@users.status">
        Status
      </label>
      <div class="relative w-full" (click)="$event.stopPropagation()">
        <button
          type="button"
          (click)="onToggleStatusMenu($event)"
          class="flex w-full appearance-none items-center justify-between rounded-[10px] border border-gray-400 bg-white py-2.5 pr-4 pl-4 text-[14px] text-gray-700 transition-colors outline-none hover:cursor-pointer hover:border-gray-600 focus:border-black">
          <span
            class="truncate"
            [class.text-gray-400]="selectedStatusId() === undefined || selectedStatusId() === null"
            [class.font-bold]="selectedStatusId() !== undefined && selectedStatusId() !== null">
            {{ getStatusLabel(selectedStatusId()) }}
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="pointer-events-none h-5 w-5 text-black transition-transform"
            [class.rotate-180]="isStatusMenuOpen()"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        @if (isStatusMenuOpen()) {
          <div
            (click)="$event.stopPropagation()"
            class="absolute z-50 mt-1 w-full rounded-[10px] border border-gray-200 bg-white shadow-lg">
            <div
              (click)="selectStatus(null)"
              class="flex cursor-pointer items-center gap-2 px-4 py-2.5 text-[14px] hover:bg-gray-50"
              [class.bg-gray-100]="selectedStatusId() === null || selectedStatusId() === undefined">
              <span>{{ getStatusLabel(null) }}</span>
            </div>
            <hr class="border-gray-100" />
            <div
              (click)="selectStatus(2)"
              class="flex cursor-pointer items-center gap-2 px-4 py-2.5 text-[14px] hover:bg-gray-50"
              [class.bg-gray-100]="selectedStatusId() === 2">
              <span>{{ getStatusLabel(2) }}</span>
            </div>
            <div
              (click)="selectStatus(1)"
              class="flex cursor-pointer items-center gap-2 px-4 py-2.5 text-[14px] hover:bg-gray-50"
              [class.bg-gray-100]="selectedStatusId() === 1">
              <span>{{ getStatusLabel(1) }}</span>
            </div>
            <div
              (click)="selectStatus(3)"
              class="flex cursor-pointer items-center gap-2 px-4 py-2.5 text-[14px] hover:bg-gray-50"
              [class.bg-gray-100]="selectedStatusId() === 3">
              <span>{{ getStatusLabel(3) }}</span>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="col-span-3 grid grid-cols-3 gap-6">
      <div class="group relative">
        <label
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
          i18n="@@createdOnFrom">
          Created From
        </label>
        <input
          type="date"
          [ngModel]="localFilters().createdFrom"
          (ngModelChange)="updateFilter('createdFrom', $event)"
          [max]="today"
          class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] text-gray-400 transition-colors outline-none hover:cursor-text hover:border-gray-600 focus:border-black"
          [class.border-red-500]="createdFromError()" />
        @if (createdFromError()) {
          <p class="mt-1 text-[12px] text-red-500">{{ createdFromError() }}</p>
        }
      </div>

      <div class="group relative">
        <label
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
          i18n="@@createdOnTo">
          Created To
        </label>
        <input
          type="date"
          [ngModel]="localFilters().createdTo"
          (ngModelChange)="updateFilter('createdTo', $event)"
          [min]="localFilters().createdFrom || ''"
          [max]="today"
          class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] text-gray-400 transition-colors outline-none hover:cursor-text hover:border-gray-600 focus:border-black"
          [class.border-red-500]="createdToError()" />
        @if (createdToError()) {
          <p class="mt-1 text-[12px] text-red-500">{{ createdToError() }}</p>
        }
      </div>

      <div></div>

      <div class="group relative">
        <label
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
          i18n="@@lastModificationDateFrom">
          Last Modification Date From
        </label>
        <input
          type="date"
          [ngModel]="localFilters().lastModifiedOnFrom"
          (ngModelChange)="updateFilter('lastModifiedOnFrom', $event)"
          [max]="today"
          class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] text-gray-400 transition-colors outline-none hover:cursor-text hover:border-gray-600 focus:border-black"
          [class.border-red-500]="updatedFromError()" />
        @if (updatedFromError()) {
          <p class="mt-1 text-[12px] text-red-500">{{ updatedFromError() }}</p>
        }
      </div>

      <div class="group relative">
        <label
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
          i18n="@@lastModificationDateTo">
          Last Modification Date To
        </label>
        <input
          type="date"
          [ngModel]="localFilters().lastModifiedOnTo"
          (ngModelChange)="updateFilter('lastModifiedOnTo', $event)"
          [min]="localFilters().lastModifiedOnFrom || ''"
          [max]="today"
          class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] text-gray-400 transition-colors outline-none hover:cursor-text hover:border-gray-600 focus:border-black"
          [class.border-red-500]="updatedToError()" />
        @if (updatedToError()) {
          <p class="mt-1 text-[12px] text-red-500">{{ updatedToError() }}</p>
        }
      </div>

      <div></div>
    </div>
  </div>

  <div class="section-border flex justify-between gap-6 border-t pt-6 pb-4" [dir]="isArabic() ? 'rtl' : 'ltr'">
    <div class="flex flex-col gap-1.5">
      <div class="group relative max-w-[275px]">
        <label
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
          i18n="@@adminProductsSortBy">
          Sort By
        </label>
        <div class="flex gap-2">
          <div class="relative w-full">
            <select
              [ngModel]="localFilters().orderBy"
              (ngModelChange)="updateFilter('orderBy', $event)"
              class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] text-gray-700 transition-colors outline-none hover:cursor-pointer hover:border-gray-600 focus:border-black ltr:pr-10 ltr:pl-4 rtl:pr-4 rtl:pl-10">
              <option value="CREATION_DATE" i18n="@@adminCategoriesSortCreatedDate">Creation Date</option>
              <option value="LAST_MODIFICATION_DATE" i18n="@@adminPharmaciesSortLastModified">Last Modified</option>
            </select>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="pointer-events-none absolute top-1/2 h-5 w-5 -translate-y-1/2 text-black ltr:right-3 rtl:left-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
          <button
            (click)="onToggleSortOrder()"
            class="w-[100px] rounded-[10px] border border-gray-400 bg-white px-2.5 py-2.5 text-[14px] font-[500] text-gray-700 transition-colors hover:cursor-pointer hover:border-gray-600 hover:bg-gray-50 focus:border-black focus:outline-none">
            @if (localFilters().orderDir === "DESC") {
              <span i18n="@@adminCategoriesSortAsc">ASC</span>
            } @else {
              <span i18n="@@adminCategoriesSortDesc">DESC</span>
            }
          </button>
        </div>
      </div>
    </div>

    <div class="col-span-2 flex items-end justify-end gap-3">
      <button
        (click)="onResetFilters()"
        class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-5 py-1.5 text-[13px] font-[500] hover:cursor-pointer">
        <span i18n="@@adminProductsResetButton">Clear</span>
      </button>
      <button
        (click)="onApplyFilters()"
        [disabled]="hasDateErrors()"
        class="bg-primary hover-bg-primary-hover rounded-[6px] px-5 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer disabled:cursor-not-allowed disabled:opacity-60">
        <span i18n="@@adminProductsApplyButton">Apply</span>
      </button>
    </div>
  </div>
</div>
